export const varifyColumns = (columns) => {
  try {
    const { heb, en } = columns;
    if (!heb || !en) return false;
    if (heb.length !== en.length) return false;
    if (en.length === 0) return false;
    if (en.some((col) => !("label" in col) && !("dataKey" in col)))
      return false;
    return true;
  } catch (e) {
    return false;
  }
};
